import React, { useState, useEffect, useContext, useRef } from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useMediaQuery, useTheme } from '@material-ui/core';
import { isNil } from "lodash";
import {
  CircularProgress,
  ClickAwayListener,
  IconButton,
  InputBase,
  makeStyles,
  Paper,
  Hidden,
  Menu,
  MenuItem,
  Tooltip,
  Fab,
} from "@material-ui/core";
import {
  blue,
  green,
  pink,
  grey,
} from "@material-ui/core/colors";
import {
  AttachFile,
  CheckCircleOutline,
  Clear,
  Description,
  HighlightOff,
  Mic,
  Mood,
  MoreVert,
  Send,
  PermMedia,
  Person,
  Reply,
  Duo,
  Timer,
} from "@material-ui/icons";
// Ícones MUI v5 para semântica melhor
import GestureIcon from '@mui/icons-material/Gesture';
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from "@material-ui/icons/Add";
import { CameraAlt } from "@material-ui/icons";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import RecordingTimer from "./RecordingTimer";

// 🎬 Componente moderno de mídia para preview
import MediaRenderer from "../MessagesList/components/MediaRenderer";
// Util para truncar texto de quoted/preview
import { truncateQuotedText } from "../MessagesList/utils/messageFormatters";
import { LAYOUT_CONFIG } from "../MessagesList/constants/messageConstants";

import useQuickMessages from "../../hooks/useQuickMessages";
import { isString, isEmpty } from "lodash";
import ContactSendModal from "../ContactSendModal";
import CameraModal from "../CameraModal";
import axios from "axios";

import useCompanySettings from "../../hooks/useSettings/companySettings";
import { ForwardMessageContext } from "../../context/ForwarMessage/ForwardMessageContext";
import MessageUploadMedias from "../MessageUploadMedias";
import { EditMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import ScheduleModal from "../ScheduleModal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Submenus } from "./submenu";
import ToolTip from '../ToolTips';


const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles((theme) => ({
  mainWrapper: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      bottom: 0,
      width: "100%",
    },
  },
  avatar: {
    width: "50px",
    height: "50px",
    borderRadius: "25%",
  },
  dropInfo: {
    background: "#eee",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    padding: 15,
    left: 0,
    right: 0,
  },
  dropInfoOut: {
    display: "none",
  },
  gridFiles: {
    maxHeight: "100%",
    overflow: "scroll",
  },
  newMessageBox: {
    background: theme.palette.background.default,
    width: "100%",
    display: "flex",
    padding: "7px",
    alignItems: "center",
  },
  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    background: theme.palette.background.paper,
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },
  messageInputWrapperPrivate: {
    padding: 6,
    marginRight: 7,
    background: "#F0E68C",
    display: "flex",
    borderRadius: 20,
    flex: 1,
    position: "relative",
  },
  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",

  },
  messageInputPrivate: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
    color: grey[800],

  },
  sendMessageIcons: {
    color: grey[700],
  },
  ForwardMessageIcons: {
    color: grey[700],
    transform: 'scaleX(-1)'
  },
  uploadInput: {
    display: "none",
  },
  viewMediaInputWrapper: {
    maxHeight: "100%",
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.mode === 'light' ? "#ffffff" : "#202c33",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },
  emojiBox: {
    position: "absolute",
    bottom: 63,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },
  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },
  audioLoading: {
    color: green[500],
    opacity: "70%",
  },
  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },
  cancelAudioIcon: {
    color: "red",
  },
  sendAudioIcon: {
    color: "green",
  },
  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 8,
    paddingLeft: 73,
    paddingRight: 7,
    backgroundColor: theme.palette.optionsBackground,
    // Espaço para não ficar colado ao input
    marginBottom: 8,
    // Evita que conteúdo interno gere barra horizontal na página
    overflowX: "hidden",
    maxWidth: "100%",
    boxSizing: "border-box",
  },
  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: theme.mode === "light" ? "#f0f0f0" : "#1d282f", //"rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
    // Impede que o container estoure para além da área do compositor
    maxWidth: "100%",
    overflowX: "hidden",
    // Permite encolhimento dentro do flex do wrapper
    minWidth: 0,
    width: "100%",
    boxSizing: "border-box",
    flexShrink: 1,
  },
  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "flex",
    flexDirection: "column",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
    // Permite o encolhimento correto em layout flex (necessário para ellipsis funcionar)
    minWidth: 0,
    maxWidth: "100%",
    width: "100%",
    boxSizing: "border-box",
    flexShrink: 1,
  },
  
  // 🎯 NOVOS: Estilos para preview de mídia
  replyPreviewMediaContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(0.5),
    maxWidth: "100%",
    overflow: "hidden",
  },
  
  replyPreviewText: {
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
    lineHeight: 1.4,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    // Garante que o ellipsis aconteça dentro do flex container
    display: "block",
    minWidth: 0,
    width: "100%",
    maxWidth: "100%",
  },
  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },
  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },
  messageContactName: {
    display: "block",
    color: "#6bcbef",
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    minWidth: 0,
    maxWidth: "100%",
  },
  messageQuickAnswersWrapper: {
    margin: 0,
    position: "absolute",
    bottom: "50px",
    background: theme.palette.background.default,
    padding: 0,
    border: "none",
    left: 0,
    width: "100%",
    "& li": {
      listStyle: "none",
      "& a": {
        display: "block",
        padding: "8px",
        textOverflow: "ellipsis",
        overflow: "hidden",
        maxHeight: "30px",
        "&:hover": {
          background: theme.palette.background.paper,
          cursor: "pointer",
        },
      },
    },
  },
  invertedFabMenu: {
    border: "none",
    borderRadius: 50, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    padding: theme.spacing(1),
    backgroundColor: "transparent",
    color: "grey",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "&:disabled": {
      backgroundColor: "transparent !important",
    },
  },
  invertedFabMenuMP: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: blue[800],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCont: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: blue[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuMeet: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    minHeight: "auto",
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: green[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuDoc: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: "#7f66ff",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  invertedFabMenuCamera: {
    border: "none",
    borderRadius: 0, // Define o raio da borda para 0 para remover qualquer borda
    boxShadow: "none", // Remove a sombra
    width: theme.spacing(4), // Ajuste o tamanho de acordo com suas preferências
    height: theme.spacing(4),
    backgroundColor: "transparent",
    color: pink[500],
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  flexContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
  },
  flexItem: {
    flex: 1,
  },
}));

const MessageInput = ({ ticketId, ticketStatus, droppedFiles, contactId, ticketChannel }) => {

  const classes = useStyles();
  const theme = useTheme();
  const [mediasUpload, setMediasUpload] = useState([]);
  const [mediaUploading, setMediaUploading] = useState(false);
  const [mediaProgressList, setMediaProgressList] = useState([]); // porcentagens por arquivo
  const [mediaCancelTokens, setMediaCancelTokens] = useState([]); // fontes de cancelamento axios por índice
  const [mediaTempIds, setMediaTempIds] = useState([]); // ids temporários por arquivo para atualizar a UI
  const isMounted = useRef(true);

  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [recording, setRecording] = useState(false);
  const [quickAnswers, setQuickAnswer] = useState([]);
  const [typeBar, setTypeBar] = useState(false);
  const inputRef = useRef();
  const [onDragEnter, setOnDragEnter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { setReplyingMessage, replyingMessage } = useContext(ReplyMessageContext);
  const { setEditingMessage, editingMessage } = useContext(EditMessageContext);
  const { user } = useContext(AuthContext);
  const [appointmentModalOpen, setAppointmentModalOpen] = useState(false);

  const [signMessagePar, setSignMessagePar] = useState(false);
  const { get: getSetting } = useCompanySettings();
  const [signMessage, setSignMessage] = useState(true);
  const [privateMessage, setPrivateMessage] = useState(false);
  const [privateMessageInputVisible, setPrivateMessageInputVisible] = useState(false);
  const [senVcardModalOpen, setSenVcardModalOpen] = useState(false);
  const [showModalMedias, setShowModalMedias] = useState(false);
  const [mediaUrl, setMediaUrl] = useState('');
  const [mediaName, setMediaName] = useState('');
  const [messages, setMessages] = useState([]);
  const [initialCaptions, setInitialCaptions] = useState([]);
  // UUID do ticket vindo da rota (usado pela MessagesList via useParams)
  const { ticketId: routeTicketUuid } = useParams();

  // Logo após const [inputMessage, setInputMessage] = useState("");
  const [originalSignature, setOriginalSignature] = useState(null);


  const { listNotCategory: listQuickMessages } = useQuickMessages();


  const isMobile = useMediaQuery('(max-width: 767px'); // Ajuste o valor conforme necessário
  const [placeholderText, setPlaceHolderText] = useState("");

  // Normaliza URL de mídia das Respostas Rápidas:
  // - Se for relativa, prefixa com BACKEND_URL/public
  // - Se for absoluta e apontar para localhost:443, substitui pela origin de BACKEND_URL
  const getQuickMediaUrl = (mediaPath) => {
    const baseUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';
    if (!mediaPath) return null;
    try {
      const isAbs = /^(https?:)?\/\//i.test(mediaPath);
      if (!isAbs) {
        return `${baseUrl}/public/${mediaPath}`;
      }
      // Absoluta: se vier com localhost:443 (inconsistência antiga), reescreve para baseUrl
      const u = new URL(mediaPath);
      if (u.hostname === 'localhost' && u.port === '443') {
        const b = new URL(baseUrl);
        return `${b.origin}${u.pathname}${u.search}${u.hash}`;
      }
      return mediaPath;
    } catch {
      return `${baseUrl}/public/${mediaPath}`;
    }
  };

  // Gera um ID de cliente estável para conciliação (usa crypto.randomUUID se disponível)
  const generateClientMessageId = () => {
    try {
      if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
      }
    } catch {}
    return `cmi-${Date.now()}-${Math.floor(Math.random() * 1e9)}`;
  };

  // Determine o texto do placeholder com base no ticketStatus
  useEffect(() => {
    if (ticketStatus === "open" || ticketStatus === "group") {
      setPlaceHolderText(i18n.t("messagesInput.placeholderOpen"));
    } else {
      setPlaceHolderText(i18n.t("messagesInput.placeholderClosed"));
    }

    // Limitar o comprimento do texto do placeholder apenas em ambientes mobile
    const maxLength = isMobile ? 20 : Infinity; // Define o limite apenas em mobile

    if (isMobile && placeholderText.length > maxLength) {
      setPlaceHolderText(placeholderText.substring(0, maxLength) + "...");
    }
  }, [ticketStatus])

  const {
    selectedMessages,
    setForwardMessageModalOpen,
    showSelectMessageCheckbox } = useContext(ForwardMessageContext);

  useEffect(() => {
    if (droppedFiles && droppedFiles.length > 0) {
      const selectedMedias = Array.from(droppedFiles);
      setMediasUpload(selectedMedias);
      setMediaProgressList(new Array(selectedMedias.length).fill(0));
      setMediaCancelTokens(new Array(selectedMedias.length).fill(null));
      setMediaTempIds(new Array(selectedMedias.length).fill(null));
      setShowModalMedias(true);
    }
  }, [droppedFiles]);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (editingMessage) {
      // Regex para capturar "*AlgumaCoisa:*" + quebras de linha e o resto
      const signatureRegex = /^\*([^:]+):\*\s*\n+\n?([\s\S]*)$/;
      const match = signatureRegex.exec(editingMessage.body);

      if (match) {
        // match[1] = "Fulano" ou "Fulano - Mensagem Privada"
        // match[2] = texto que vem depois da assinatura
        setOriginalSignature(match[1]);
        setInputMessage(match[2]);
      } else {
        // Não tinha assinatura
        setOriginalSignature(null);
        setInputMessage(editingMessage.body);
      }
    } else {
      // Se não está editando nada, limpa
      setOriginalSignature(null);
      setInputMessage("");
    }
  }, [editingMessage]);


  useEffect(() => {
    inputRef.current.focus();
    return () => {
      setInputMessage("");
      setShowEmoji(false);
      setMediasUpload([]);
      setReplyingMessage(null);
      //setSignMessage(true);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false)
      setEditingMessage(null);
    };
  }, [ticketId, setReplyingMessage, setEditingMessage]);

  useEffect(() => {
    setTimeout(() => {
      if (isMounted.current)
        setOnDragEnter(false);
    }, 1000);
    // eslint-disable-next-line
  }, [onDragEnter === true]);

  //permitir ativar/desativar firma
  useEffect(() => {
    const fetchSettings = async () => {
      const setting = await getSetting({
        "column": "sendSignMessage"
      });

      if (isMounted.current) {
        if (setting.sendSignMessage === "enabled") {
          setSignMessagePar(true);
          const signMessageStorage = JSON.parse(
            localStorage.getItem("persistentSignMessage")
          );
          if (isNil(signMessageStorage)) {
            setSignMessage(true)
          } else {
            setSignMessage(signMessageStorage);
          }
        } else {
          setSignMessagePar(false);
        }
      }
    };
    fetchSettings();
  }, []);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  // Helpers para notificar a MessagesList imediatamente (sem depender do socket)
  const dispatchTempAdd = (tempMessage) => {
    try {
      window.dispatchEvent(
        new CustomEvent("chat:add-temp-message", {
          detail: { ticketId: routeTicketUuid, message: tempMessage },
        })
      );
    } catch {}
  };

  const dispatchTempUpdate = (clientMessageId, data) => {
    try {
      window.dispatchEvent(
        new CustomEvent("chat:update-temp-message", {
          detail: { ticketId: routeTicketUuid, clientMessageId, data },
        })
      );
    } catch {}
  };

  const addAudioToUI = (audio) => {
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupCollapsed('[send] temp audio add', { id: audio.id, clientMessageId: audio.clientMessageId, mediaType: audio.mediaType, createdAt: audio.createdAt }); } catch {}
    setMessages((prevMessages) => [...prevMessages, audio]);
    dispatchTempAdd(audio);
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupEnd(); } catch {}
  };

  const updateAudioInUI = (tempId, newAudioData) => {
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupCollapsed('[send] temp audio update', { tempId, clientMessageId: newAudioData?.clientMessageId, status: newAudioData?.status, id: newAudioData?.id }); } catch {}
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.id === tempId ? { ...msg, ...newAudioData } : msg
      )
    );
    if (newAudioData?.clientMessageId) {
      dispatchTempUpdate(newAudioData.clientMessageId, newAudioData);
    }
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupEnd(); } catch {}
  };


  const addMessageToUI = (message) => {
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupCollapsed('[send] temp message add', { id: message.id, clientMessageId: message.clientMessageId, mediaType: message.mediaType, createdAt: message.createdAt }); } catch {}
    setMessages((prevMessages) => [...prevMessages, message]);
    dispatchTempAdd(message);
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupEnd(); } catch {}
  };

  const updateMessageInUI = (tempId, newMessageData) => {
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupCollapsed('[send] temp message update', { tempId, clientMessageId: newMessageData?.clientMessageId, status: newMessageData?.status, id: newMessageData?.id }); } catch {}
    setMessages((prevMessages) =>
      prevMessages.map((msg) =>
        msg.id === tempId ? { ...msg, ...newMessageData } : msg
      )
    );
    if (newMessageData?.clientMessageId) {
      dispatchTempUpdate(newMessageData.clientMessageId, newMessageData);
    }
    try { if (window?.localStorage?.getItem('debugSend') === '1') console.groupEnd(); } catch {}
  };


  const handleSendLinkVideo = async () => {
    const uniqueCode = ticketId * 5;
    const timestamp = Date.now();

    // Link com o ticketId + ticketId multiplicado por 5 + timestamp
    const link = `https://meet.jit.si/${ticketId}-${uniqueCode}-${timestamp}`;

    setInputMessage(link); // Link gerado
  };


  const handleChangeInput = (e) => {
    setInputMessage(e.target.value);
  };

  const handlePrivateMessage = (e) => {
    setPrivateMessage(!privateMessage);
    setPrivateMessageInputVisible(!privateMessageInputVisible);
  };

  const handleQuickAnswersClick = async (value) => {
    // Normaliza campos vindos do submenu (objeto completo) e do typeahead (objeto com .value)
    const quickText = value?.value ? value.value : value?.message;
    const quickMediaPath = value?.mediaPath;
    const quickMediaName = value?.mediaName;
    const isEditable = value?.geral === true; // usar flag 'geral' como "permite editar"

    // Caso editável: não enviar direto
    if (isEditable) {
      try {
        if (quickMediaPath) {
          // Baixa o arquivo e abre o modal de mídias com a legenda pré-preenchida
          const downloadUrl = getQuickMediaUrl(quickMediaPath);
          const { data: blob } = await axios.get(downloadUrl, { responseType: "blob" });
          const filename = quickMediaName || `arquivo_${Date.now()}`;
          const file = new File([blob], filename, { type: blob.type || "application/octet-stream" });

          const selectedMedias = [file];
          setMediasUpload(selectedMedias);
          setMediaProgressList(new Array(selectedMedias.length).fill(0));
          setMediaCancelTokens(new Array(selectedMedias.length).fill(null));
          setMediaTempIds(new Array(selectedMedias.length).fill(null));
          setInitialCaptions([quickText || ""]);
          setShowModalMedias(true);
        } else {
          // Texto puro: jogar no input para o usuário editar/enviar manualmente
          setInputMessage(quickText || "");
          try { inputRef.current && inputRef.current.focus(); } catch {}
        }
      } catch (err) {
        toastError(err);
      }
      return;
    }

    if (quickMediaPath) {
      try {
        // Monta URL correta para baixar o anexo da resposta rápida (corrige localhost:443 -> backend).
        const mediaUrl = getQuickMediaUrl(quickMediaPath);

        const { data } = await axios.get(mediaUrl, {
          responseType: "blob",
        });

        await handleUploadQuickMessageMedia(data, quickText);
        setInputMessage("");
        return;
        //  handleChangeMedias(response)
      } catch (err) {
        toastError(err);
      }
    }

    // Sem mídia: envia direto e deixa o socket adicionar a mensagem final (sem temp em branco)
    try {
      const userName = privateMessage ? `${user.name} - Mensagem Privada` : user.name;
      const payloadBody = (signMessage || privateMessage)
        ? `*${userName}:*\n\n${quickText}`
        : quickText;

      const clientMessageId = generateClientMessageId();
      const payload = {
        body: payloadBody,
        quotedMsg: replyingMessage,
        isPrivate: privateMessage ? 'true' : 'false',
        clientMessageId,
      };
      await api.post(`/messages/${ticketId}`, payload);
    } catch (err) {
      toastError(err);
    } finally {
      setReplyingMessage(null);
      setEditingMessage(null);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
      setInputMessage("");
      setTypeBar(false);
    }
  };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const [modalCameraOpen, setModalCameraOpen] = useState(false);

  const handleCapture = (imageData) => {
    if (imageData) {
      handleUploadCamera(imageData);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }
    const selectedMedias = Array.from(e.target.files);
    setMediasUpload(selectedMedias);
    setMediaProgressList(new Array(selectedMedias.length).fill(0));
    setMediaCancelTokens(new Array(selectedMedias.length).fill(null));
    setMediaTempIds(new Array(selectedMedias.length).fill(null));
    setShowModalMedias(true);
  };

  const handleChangeSign = (e) => {
    getStatusSingMessageLocalstogare();
  };

  const handleOpenModalForward = () => {
    if (selectedMessages.length === 0) {
      setForwardMessageModalOpen(false)
      toastError(i18n.t("messagesList.header.notMessage"));
      return;
    }
    setForwardMessageModalOpen(true);
  }

  const getStatusSingMessageLocalstogare = () => {
    const signMessageStorage = JSON.parse(
      localStorage.getItem("persistentSignMessage")
    );
    //si existe uma chave "sendSingMessage"
    if (signMessageStorage !== null) {
      if (signMessageStorage) {
        localStorage.setItem("persistentSignMessage", false);
        setSignMessage(false);
      } else {
        localStorage.setItem("persistentSignMessage", true);
        setSignMessage(true);
      }
    } else {
      localStorage.setItem("persistentSignMessage", false);
      setSignMessage(false);
    }
  };

  const handleInputPaste = (e) => {
    if (e.clipboardData.files[0]) {
      const selectedMedias = Array.from(e.clipboardData.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleInputDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files[0]) {
      const selectedMedias = Array.from(e.dataTransfer.files);
      setMediasUpload(selectedMedias);
      setShowModalMedias(true);
    }
  };

  const handleUploadMedia = async (items) => {
    // items: [{ file, caption }]
    // Upload 1:1 por arquivo para suportar progresso individual e conciliação
    if (!items?.length) return;

    setMediaUploading(true);
    // Não travar o input de texto durante upload de mídia

    // Helper para derivar um tipo textual opcional
    const getMediaType = (file) => {
      const t = (file?.type || '').toLowerCase();
      if (t.startsWith('image/')) return 'image';
      if (t.startsWith('video/')) return 'video';
      if (t.startsWith('audio/')) return 'audio';
      if (t === 'application/pdf') return 'application';
      return undefined;
    };

    const newTempIds = [...mediaTempIds];
    const newCancelTokens = [...mediaCancelTokens];
    const newProgress = [...mediaProgressList];

    for (let i = 0; i < items.length; i++) {
      const { file, caption } = items[i];
      const clientMessageId = generateClientMessageId();
      // Cria mensagem temporária
      const tempId = `temp-${Date.now()}-${i}`;
      newTempIds[i] = tempId;
      const objectUrl = URL.createObjectURL(file);
      const tempMessage = {
        id: tempId,
        fromMe: true,
        body: caption || '',
        isPrivate: !!privateMessage,
        status: 'sending',
        mediaUrl: objectUrl,
        mediaType: getMediaType(file),
        clientMessageId,
        createdAt: new Date().toISOString(),
        ticketId: ticketId,
      };
  addMessageToUI(tempMessage);

      // Monta formData por arquivo
      const formData = new FormData();
  formData.append('fromMe', true);
  formData.append('isPrivate', privateMessage ? 'true' : 'false');
      formData.append('isPrivate', privateMessage ? 'true' : 'false');
      if (replyingMessage) {
        formData.append('quotedMsg', replyingMessage);
      }
      formData.append('body', caption || '');
      formData.append('medias', file);
      formData.append('clientMessageId', clientMessageId);

      // Cancel token por item
      const source = api.CancelToken ? api.CancelToken.source() : null;
      if (source) newCancelTokens[i] = source;

      try {
        const { data } = await api.post(`/messages/${ticketId}`,
          formData,
          {
            cancelToken: source ? source.token : undefined,
            onUploadProgress: (evt) => {
              if (!evt?.total) return;
              const pct = Math.round((evt.loaded * 100) / evt.total);
              newProgress[i] = pct;
              setMediaProgressList([...newProgress]);
            }
          }
        );
        updateMessageInUI(tempId, { ...data, clientMessageId });
      } catch (err) {
  toastError(err);
  updateMessageInUI(tempId, { status: 'failed', clientMessageId });
      }
    }

    setMediaTempIds(newTempIds);
    setMediaCancelTokens(newCancelTokens);
    setMediaUploading(false);
    setMediasUpload([]);
    setShowModalMedias(false);
    setPrivateMessage(false);
    setPrivateMessageInputVisible(false);
    // limpa barras de progresso
    setMediaProgressList([]);
  };

  const handleCancelUploadAtIndex = (index) => {
    try {
      const src = mediaCancelTokens[index];
      if (src && typeof src.cancel === 'function') {
        src.cancel('Upload cancelado pelo usuário');
      }
    } catch (e) {
      // noop
    }
  };

  const handleSendContatcMessage = async (vcard) => {
    // Fecha o modal e inicia estado de envio
    setSenVcardModalOpen(false);
    setLoading(true);

    // Se o modal for fechado sem seleção, apenas retorna
    if (isNil(vcard)) {
      setLoading(false);
      return;
    }

    try {
      const clientMessageId = generateClientMessageId();
      const tempId = `temp-${Date.now()}-vcard`;

      // Mensagem temporária para refletir imediatamente na UI
      const tempMessage = {
        id: tempId,
        fromMe: true,
        body: "",
        isPrivate: !!privateMessage,
        status: "sending",
        mediaType: "contactMessage",
        vCard: { name: vcard?.name, number: vcard?.number },
        clientMessageId,
        createdAt: new Date().toISOString(),
        ticketId: ticketId,
      };
      addMessageToUI(tempMessage);

      // Monta payload para API (isPrivate como string)
      const payload = {
        body: null,
        quotedMsg: replyingMessage,
        isPrivate: privateMessage ? "true" : "false",
        vCard: { name: vcard?.name, number: vcard?.number },
        clientMessageId,
      };

      const { data } = await api.post(`/messages/${ticketId}`, payload);
      // Concilia a resposta com a mensagem temporária
      updateMessageInUI(tempId, { ...data, clientMessageId });

    } catch (err) {
      toastError(err);
      // Marca a mensagem temporária como falha, se existir
      try {
        updateMessageInUI && updateMessageInUI(`temp-${Date.now()}-vcard`, { status: "failed" });
      } catch {}
    } finally {
      // Limpa estados de interface
      setInputMessage("");
      setShowEmoji(false);
      setLoading(false);
      setReplyingMessage(null);
      setEditingMessage(null);
      setPrivateMessage(false);
      setPrivateMessageInputVisible(false);
    }
  };

  const handleSendMessage = async () => {
    // Se o campo de mensagem estiver vazio, não faz nada
    if (inputMessage.trim() === "") return;

    // Se estivermos editando uma mensagem, entra no fluxo de edição
    if (editingMessage !== null) {
      // Regex para checar se já existe assinatura no formato
      // *Fulano:* + \n\n + texto
      const signatureRegex = /^\*([^:]+):\*\s*\n+([\s\S]+)$/m;
      const match = signatureRegex.exec(editingMessage.body);

      // Texto que o usuário digitou ao editar
      const newText = inputMessage.trim();
      let updatedBody;

      if (match) {
        // Se encontramos a assinatura, o grupo 1 é o nome; grupo 2 é o texto antigo.
        // Vamos preservar "*Nome:*" e só trocar o trecho posterior.
        const userSignature = match[1]; // Ex.: Fulano ou Fulano - Mensagem Privada
        updatedBody = `*${userSignature}:*\n\n${newText}`;
      } else {
        // Se não há assinatura, não adicionamos; apenas usamos o texto que o usuário digitou.
        updatedBody = newText;
      }

      // Monta o objeto atualizado
      const updatedMessage = {
        ...editingMessage,
        body: updatedBody,
      };

      try {
        const { data } = await api.post(`/messages/edit/${editingMessage.id}`, updatedMessage);
        updateMessageInUI(editingMessage.id, { ...data, clientMessageId: editingMessage.clientMessageId });
      } catch (err) {
        toastError(err);
        updateMessageInUI(editingMessage.id, { status: "failed" });
      }

      // Limpa estados de edição
      setInputMessage("");
      setShowEmoji(false);
      setLoading(false);
      setReplyingMessage(null);
      setPrivateMessage(false);
      setEditingMessage(null);
      setPrivateMessageInputVisible(false);
      return;
    }


    // Fluxo para nova mensagem
    const userName = privateMessage
      ? `${user.name} - Mensagem Privada`
      : user.name;
    const sendMessage = inputMessage.trim();

    // Cria uma mensagem temporária para exibir na UI
    const clientMessageId = generateClientMessageId();
    const tempMessage = {
      id: `temp-${new Date().getTime()}`,
      fromMe: true,
      body: (signMessage || privateMessage)
        ? `*${userName}:*\n\n${sendMessage}`
        : sendMessage,
      quotedMsg: replyingMessage,
      isPrivate: !!privateMessage,
      clientMessageId,
      status: "sending",
      mediaType: "conversation",
      createdAt: new Date().toISOString(),
      ticketId: ticketId,
    };

    // Adiciona a mensagem temporária na UI
    addMessageToUI(tempMessage);
    // addMessageToUI já notifica a MessagesList via dispatchTempAdd

    // Limpa os estados da interface
    setInputMessage("");
    setShowEmoji(false);
    setReplyingMessage(null);
    setPrivateMessage(false);
    setEditingMessage(null);
    setPrivateMessageInputVisible(false);

    try {
      // Envia a nova mensagem para o endpoint de criação (mantém isPrivate como string para o backend)
      const payloadToSend = { ...tempMessage, isPrivate: privateMessage ? 'true' : 'false' };
      const { data } = await api.post(`/messages/${ticketId}`, payloadToSend);
      updateMessageInUI(tempMessage.id, { ...data, clientMessageId });
    } catch (err) {
      toastError(err);
      updateMessageInUI(tempMessage.id, { status: "failed" });
    }
  };



  const handleStartRecording = async () => {
    setLoading(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const messages = await listQuickMessages({ companyId, userId: user.id });

      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 90) {
          truncatedMessage = m.message.substring(0, 90) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
          mediaName: m.mediaName,
          geral: !!m.geral,
          id: m.id,
        };
      });
      if (isMounted.current) {

        setQuickAnswer(options);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage) &&
      inputMessage.length >= 1
    ) {
      const firstWord = inputMessage.charAt(0);

      if (firstWord === "/") {
        setTypeBar(firstWord.indexOf("/") > -1);

        const filteredOptions = quickAnswers.filter(
          (m) => m.label.toLowerCase().indexOf(inputMessage.toLowerCase()) > -1
        );
        setTypeBar(filteredOptions);
      } else {
        setTypeBar(false);
      }
    } else {
      setTypeBar(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage]);

  const disableOption = () => {
    return (
      loading ||
      recording ||
      (ticketStatus !== "open" && ticketStatus !== "group")
    );
  };

  const handleUploadCamera = async (blob) => {
    try {
      const clientMessageId = generateClientMessageId();
      const objectUrl = URL.createObjectURL(blob);
      const tempMessage = {
        id: `temp-${Date.now()}-camera`,
        fromMe: true,
        body: privateMessage ? "" : "",
        isPrivate: !!privateMessage,
        status: 'sending',
        mediaUrl: objectUrl,
        mediaType: 'image',
        clientMessageId,
        createdAt: new Date().toISOString(),
        ticketId: ticketId,
      };
      addMessageToUI(tempMessage);

      const formData = new FormData();
      const filename = `${new Date().getTime()}.png`;
      formData.append("medias", blob, filename);
      formData.append("body", privateMessage ? `\u200d` : "");
  formData.append("fromMe", true);
  formData.append("isPrivate", privateMessage ? 'true' : 'false');
      formData.append("clientMessageId", clientMessageId);

      api.post(`/messages/${ticketId}`, formData)
        .then(({ data }) => {
          updateMessageInUI(tempMessage.id, { ...data, clientMessageId });
        })
        .catch((err) => {
          toastError(err);
          updateMessageInUI(tempMessage.id, { status: 'failed', clientMessageId });
        });
    } catch (err) {
      toastError(err);
    }
  };

  const handleUploadQuickMessageMedia = async (blob, message) => {
    try {
      const extension = (blob.type.split("/")[1] || '').toLowerCase();
      const typeHint = blob.type.startsWith('image/') ? 'image' : blob.type.startsWith('video/') ? 'video' : blob.type.startsWith('audio/') ? 'audio' : (extension === 'pdf' ? 'application' : undefined);
      const userName = privateMessage ? `${user.name} - Mensagem Privada` : user.name;
      const payloadBody = (signMessage || privateMessage)
        ? `*${userName}:*\n\n${message}`
        : message;

      const clientMessageId = generateClientMessageId();
      const objectUrl = URL.createObjectURL(blob);
      const tempMessage = {
        id: `temp-${Date.now()}-quick`,
        fromMe: true,
        body: "\u200d", // evita exibir placeholders antes da expansão
        isPrivate: !!privateMessage,
        status: 'sending',
        mediaUrl: objectUrl,
        mediaType: typeHint,
        clientMessageId,
        createdAt: new Date().toISOString(),
        ticketId: ticketId,
      };
      addMessageToUI(tempMessage);

      const formData = new FormData();
      const filename = `${new Date().getTime()}.${extension || 'bin'}`;
      formData.append("medias", blob, filename);
      formData.append("body", payloadBody);
  formData.append("fromMe", true);
  formData.append("isPrivate", privateMessage ? 'true' : 'false');
      formData.append("clientMessageId", clientMessageId);
      if (replyingMessage) {
        // Alinha com o mesmo padrão adotado no envio de áudio
        formData.append('quotedMsgId', replyingMessage?.id);
      }

      api.post(`/messages/${ticketId}`, formData)
        .then(({ data }) => {
          updateMessageInUI(tempMessage.id, { ...data, clientMessageId });
        })
        .catch((err) => {
          toastError(err);
          updateMessageInUI(tempMessage.id, { status: 'failed', clientMessageId });
        });
    } catch (err) {
      toastError(err);
    }
  };


  const handleUploadAudio = async () => {
    setLoading(true);

    let tempAudio = null;
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size < 10000) {
        setLoading(false);
        setRecording(false);
        return;
      }

      const clientMessageId = generateClientMessageId();
      tempAudio = {
        id: `temp-${new Date().getTime()}`,
        fromMe: true,
        body: "", // corpo vazio para áudio
        mediaUrl: URL.createObjectURL(blob),
        status: "sending",
        mediaType: "audio",
        clientMessageId,
        createdAt: new Date().toISOString(),
        ticketId: ticketId,
        isPrivate: !!privateMessage,
      };

      // Adiciona imediatamente à UI local e avisa a MessagesList
      addAudioToUI(tempAudio);

      // Libera imediatamente a UI de gravação/input
      setRecording(false);
      setLoading(false);
      setReplyingMessage(null);

      // Dispara o upload em background (não bloqueante)
      const formData = new FormData();
      const filename = `${new Date().getTime()}.mp3`;
      formData.append("medias", blob, filename);
      formData.append("body", filename);
  formData.append("fromMe", true);
  formData.append("isPrivate", privateMessage ? 'true' : 'false');
      formData.append("clientMessageId", tempAudio.clientMessageId);
      if (replyingMessage) {
        formData.append("quotedMsgId", replyingMessage?.id);
      }

      api.post(`/messages/${ticketId}`, formData)
        .then(({ data }) => {
          // Força reconciliação pela clientMessageId: a MessagesList receberá update-temp
          // e converterá a bolha temporária para o id do servidor, evitando duplicação.
          updateAudioInUI(tempAudio.id, { ...data, clientMessageId: tempAudio.clientMessageId });
        })
        .catch((err) => {
          toastError(err);
          if (tempAudio) {
            updateAudioInUI(tempAudio.id, { status: 'failed' });
          }
        });

    } catch (err) {
      toastError(err);
      setLoading(false);
      setRecording(false);
    }
  };


  const handleCloseModalMedias = () => {
    setShowModalMedias(false);
  };
  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
    } catch (err) {
      toastError(err);
    }
  };

  const handleOpenMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event) => {
    setAnchorEl(null);
  };

  const handleSendContactModalOpen = async () => {
    handleMenuItemClick();
    setSenVcardModalOpen(true);
  };

  const handleCameraModalOpen = async () => {
    handleMenuItemClick();
    setModalCameraOpen(true);
  };

  const handleCancelSelection = () => {
    setMediasUpload([]);
    setShowModalMedias(false);
    setMediaProgressList([]);
    setMediaCancelTokens([]);
    setMediaTempIds([]);
  };

  const renderReplyingMessage = (message) => {
    const previewText = truncateQuotedText(
      String(message?.body || ""),
      LAYOUT_CONFIG?.QUOTED_MESSAGE_MAX_LENGTH || 100
    );
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          {replyingMessage && (
            <div className={classes.replyginMsgBody}>
              {!message.fromMe && (
                <span className={classes.messageContactName}>
                  {message.contact?.name}
                </span>
              )}
              
              {/* 🎯 NOVA: Mídia no preview de resposta */}
              {message.mediaUrl && (
                <div className={classes.replyPreviewMediaContainer}>
                  <MediaRenderer 
                    message={message} 
                    variant="preview" 
                    size="small"
                  />
                </div>
              )}
              
              {/* Texto da mensagem - apenas se não for mídia visual ou se tiver texto relevante */}
              {message.body && 
               message.mediaType !== "image" && 
               message.mediaType !== "video" && 
               message.mediaType !== "contactMessage" && 
               message.mediaType !== "application" && (
                <div className={classes.replyPreviewText}>
                  {previewText?.displayText || ""}
                </div>
              )}
            </div>
          )}
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={disableOption()}
          onClick={() => {
            setReplyingMessage(null);
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <Clear className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  // Mantém sempre o input visível; o modal aparece sobreposto quando necessário
  {
    return (
      <>
        {showModalMedias && (
          <MessageUploadMedias
            isOpen={showModalMedias}
            files={mediasUpload}
            onClose={handleCloseModalMedias}
            onSend={handleUploadMedia}
            onCancelSelection={handleCancelSelection}
            uploading={mediaUploading}
            progressList={mediaProgressList}
            onCancelUpload={handleCancelUploadAtIndex}
            initialCaptions={initialCaptions}
          />
        )}
        {modalCameraOpen && (
          <CameraModal
            isOpen={modalCameraOpen}
            onRequestClose={() => setModalCameraOpen(false)}
            onCapture={handleCapture}
          />
        )}
        {senVcardModalOpen && (
          <ContactSendModal
            modalOpen={senVcardModalOpen}
            onClose={(c) => {
              handleSendContatcMessage(c);
            }}
          />
        )}
        <Paper
          square
          elevation={0}
          className={classes.mainWrapper}
          onDragEnter={() => setOnDragEnter(true)}
          onDrop={(e) => handleInputDrop(e)}
        >
          {(replyingMessage && renderReplyingMessage(replyingMessage)) || (editingMessage && renderReplyingMessage(editingMessage))}
          <div className={classes.newMessageBox}>
            <Hidden only={["sm", "xs"]}>
              <IconButton
                aria-label="emojiPicker"
                component="span"
                disabled={disableOption()}
                onClick={(e) => setShowEmoji((prevState) => !prevState)}
              >
                <Mood className={classes.sendMessageIcons} />
              </IconButton>
              {showEmoji ? (
                <div className={classes.emojiBox}>
                  <ClickAwayListener onClickAway={(e) => setShowEmoji(false)}>
                    <Picker
                      perLine={16}
                      theme={"dark"}
                      i18n={i18n}
                      showPreview={true}
                      showSkinTones={false}
                      onSelect={handleAddEmoji}
                    />
                  </ClickAwayListener>
                </div>
              ) : null}

              <Fab
                disabled={disableOption()}
                aria-label="uploadMedias"
                component="span"
                className={classes.invertedFabMenu}
                onClick={handleOpenMenuClick}
              >
                <AddIcon />
              </Fab>
              <Menu
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
                id="simple-menu"
              >
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-img-button"
                    accept="image/*, video/*, audio/* "
                    // disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-img-button">
                    <Fab
                      aria-label="upload-img"
                      component="span"
                      className={classes.invertedFabMenuMP}
                    >
                      <PermMedia />
                    </Fab>
                    {i18n.t("messageInput.type.imageVideo")}
                  </label>
                </MenuItem>
                <MenuItem onClick={handleCameraModalOpen}>
                  <Fab className={classes.invertedFabMenuCamera}>
                    <CameraAlt />
                  </Fab>
                  {i18n.t("messageInput.type.cam")}
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-doc-button"
                    accept="application/*, text/*"
                    // disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-doc-button">
                    <Fab aria-label="upload-img"
                      component="span" className={classes.invertedFabMenuDoc}>
                      <Description />
                    </Fab>
                    Documento
                  </label>
                </MenuItem>
                <MenuItem onClick={handleSendContactModalOpen}>
                  <Fab className={classes.invertedFabMenuCont}>
                    <Person />
                  </Fab>
                  {i18n.t("messageInput.type.contact")}
                </MenuItem>
                <MenuItem onClick={handleSendLinkVideo}>
                  <Fab className={classes.invertedFabMenuMeet}>
                    <Duo />
                  </Fab>
                  {i18n.t("messageInput.type.meet")}
                </MenuItem>
              </Menu>
              {/* <IconButton
                aria-label="upload"
                component="span"
                disabled={disableOption()}
                onMouseOver={() => setOnDragEnter(true)}
              >
                <AttachFile className={classes.sendMessageIcons} />
              </IconButton> */}

              {/* </label> */}
              {signMessagePar && (
                <Tooltip title={i18n.t("messageInput.tooltip.signature")}>
                  <IconButton
                    aria-label="send-upload"
                    component="span"
                    onClick={handleChangeSign}
                  >
                    {signMessage === true ? (
                      <GestureIcon style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                    ) : (
                      <GestureIcon style={{ color: "grey" }} />
                    )}
                  </IconButton>
                </Tooltip>
              )}
              <IconButton style={{ width: 50, boder: "2px solid red" }}>
                <Submenus setInputMessage={setInputMessage} setMediaUrl={setMediaUrl} setMediaName={setMediaName} sendMessageQuick={handleQuickAnswersClick} />
              </IconButton>
              <Tooltip title={i18n.t("messageInput.tooltip.privateMessage")}>
                <IconButton
                  aria-label="send-upload"
                  component="span"
                  onClick={handlePrivateMessage}
                >
                  {privateMessage === true ? (
                    <LockIcon style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                  ) : (
                    <LockIcon style={{ color: "grey" }} />
                  )}
                </IconButton>
              </Tooltip>
              {/* <Tooltip title={i18n.t("messageInput.tooltip.meet")}>
                <IconButton
                  aria-label="send-upload"
                  component="span"
                  onClick={handleSendLinkVideo}
                >
                  <Duo style={{ color: "grey" }} />
                </IconButton>
              </Tooltip> */}
            </Hidden>
            <Hidden only={["md", "lg", "xl"]}>
              <IconButton
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleOpenMenuClick}
              >
                <MoreVert></MoreVert>
              </IconButton>
              <Menu
                id="simple-menu"
                keepMounted
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuItemClick}
              >
                <MenuItem onClick={handleMenuItemClick}>
                  <IconButton
                    aria-label="emojiPicker"
                    component="span"
                    disabled={disableOption()}
                    onClick={(e) => setShowEmoji((prevState) => !prevState)}
                  >
                    <Mood className={classes.sendMessageIcons} />
                  </IconButton>
                </MenuItem>
                <MenuItem onClick={handleMenuItemClick}>
                  <input
                    multiple
                    type="file"
                    id="upload-button"
                    disabled={disableOption()}
                    className={classes.uploadInput}
                    onChange={handleChangeMedias}
                  />
                  <label htmlFor="upload-button">
                    <IconButton
                      aria-label="upload"
                      component="span"
                      disabled={disableOption()}
                    >
                      <AttachFile className={classes.sendMessageIcons} />
                    </IconButton>
                  </label>
                </MenuItem>
                <MenuItem>
                  <IconButton style={{ width: 50, boder: "2px solid red" }}>
                    <Submenus setInputMessage={setInputMessage} setMediaUrl={setMediaUrl} setMediaName={setMediaName} sendMessageQuick={handleQuickAnswersClick} />
                  </IconButton>
                </MenuItem>
                {signMessagePar && (
                  <Tooltip title="Habilitar/Desabilitar Assinatura">
                    <IconButton
                      aria-label="send-upload"
                      component="span"
                      onClick={handleChangeSign}
                    >
                      {signMessage === true ? (
                        <GestureIcon style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                      ) : (
                        <GestureIcon style={{ color: "grey" }} />
                      )}
                    </IconButton>
                  </Tooltip>
                )}
                <Tooltip title="Habilitar/Desabilitar Comentários">
                  <IconButton
                    aria-label="send-upload"
                    component="span"
                    onClick={handlePrivateMessage}
                  >
                    {privateMessage === true ? (
                      <LockIcon style={{ color: theme.mode === "light" ? theme.palette.primary.main : "#EEE" }} />
                    ) : (
                      <LockIcon style={{ color: "grey" }} />
                    )}
                  </IconButton>
                </Tooltip>

              </Menu>
            </Hidden>
            <div className={classes.flexContainer}>
              {privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div className={classes.messageInputWrapperPrivate}>
                    <InputBase
                      inputRef={(input) => {
                        input && input.focus();
                        input && (inputRef.current = input);
                      }}
                      className={classes.messageInput}
                      placeholder={placeholderText}
                      multiline
                      maxRows={5}
                      value={inputMessage}
                      onChange={handleChangeInput}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        (ticketStatus === "open" || ticketStatus === "group") &&
                          handleInputPaste(e);
                      }}
                      // Alterado de onKeyPress para onKeyDown para ter maior controle
                      onKeyDown={(e) => {
                        // Se estiver carregando ou o usuário pressionar Shift, não fazemos nada
                        if (loading || e.shiftKey) return;
                        // Se a tecla for Enter
                        if (e.key === "Enter") {
                          e.preventDefault(); // Impede a quebra de linha padrão
                          handleSendMessage(); // Envia a mensagem
                        }
                      }}
                    />

                    {typeBar ? (
                      <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a onClick={() => handleQuickAnswersClick(value)}>
                                {`${value.label} - ${value.value}`}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
              {!privateMessageInputVisible && (
                <div className={classes.flexItem}>
                  <div className={classes.messageInputWrapper}>
                    <InputBase
                      inputRef={(input) => {
                        input && input.focus();
                        input && (inputRef.current = input);
                      }}
                      className={classes.messageInput}
                      placeholder={
                        ticketStatus === "open" || ticketStatus === "group"
                          ? i18n.t("messagesInput.placeholderPrivateMessage")
                          : i18n.t("messagesInput.placeholderClosed")
                      }
                      multiline
                      maxRows={5}
                      value={inputMessage}
                      onChange={handleChangeInput}
                      disabled={disableOption()}
                      onPaste={(e) => {
                        (ticketStatus === "open" || ticketStatus === "group") &&
                          handleInputPaste(e);
                      }}
                      onKeyDown={(e) => {
                        if (loading || e.shiftKey) return;
                        if (e.key === "Enter") {
                          e.preventDefault();
                          handleSendMessage();
                        }
                      }}
                    />

                    {typeBar ? (
                      <ul className={classes.messageQuickAnswersWrapper}>
                        {typeBar.map((value, index) => {
                          return (
                            <li
                              className={classes.messageQuickAnswersWrapperItem}
                              key={index}
                            >
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a onClick={() => handleQuickAnswersClick(value)}>
                                {`${value.label} - ${value.value}`}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    ) : (
                      <div></div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {!privateMessageInputVisible && (
              <>
                <Tooltip title={i18n.t("tickets.buttons.scredule")}>
                  <IconButton
                    aria-label="scheduleMessage"
                    component="span"
                    onClick={() => setAppointmentModalOpen(true)}
                    disabled={loading}
                  >
                    <Timer className={classes.sendMessageIcons} />
                  </IconButton>
                </Tooltip>
                {inputMessage || showSelectMessageCheckbox ? (
                  <>
                    <IconButton
                      aria-label="sendMessage"
                      component="span"
                      onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                      disabled={loading}
                    >
                      {showSelectMessageCheckbox ?
                        <Reply className={classes.ForwardMessageIcons} /> : <Send className={classes.sendMessageIcons} />}
                    </IconButton>
                  </>
                ) : recording ? (
                  <div className={classes.recorderWrapper}>
                    <IconButton
                      aria-label="cancelRecording"
                      component="span"
                      fontSize="large"
                      disabled={loading}
                      onClick={handleCancelAudio}
                    >
                      <HighlightOff className={classes.cancelAudioIcon} />
                    </IconButton>
                    {loading ? (
                      <div>
                        <CircularProgress className={classes.audioLoading} />
                      </div>
                    ) : (
                      <RecordingTimer />
                    )}

                    <IconButton
                      aria-label="sendRecordedAudio"
                      component="span"
                      onClick={handleUploadAudio}
                      disabled={loading}
                    >
                      <CheckCircleOutline className={classes.sendAudioIcon} />
                    </IconButton>
                  </div>
                ) : (
                  <IconButton
                    aria-label="showRecorder"
                    component="span"
                    disabled={disableOption()}
                    onClick={handleStartRecording}
                  >
                    <Mic className={classes.sendMessageIcons} />
                  </IconButton>
                )}
              </>
            )}

            {privateMessageInputVisible && (
              <>
                <IconButton
                  aria-label="sendMessage"
                  component="span"
                  onClick={showSelectMessageCheckbox ? handleOpenModalForward : handleSendMessage}
                  disabled={loading}
                >
                  {showSelectMessageCheckbox ?
                    <Reply className={classes.ForwardMessageIcons} /> : <Send className={classes.sendMessageIcons} />}
                </IconButton>
              </>
            )}
            {appointmentModalOpen && (
              <ScheduleModal
                open={appointmentModalOpen}
                onClose={() => setAppointmentModalOpen(false)}
                message={inputMessage}
                contactId={contactId}
              />
            )}
          </div>
        </Paper>
      </>
    );
  }
};

export default MessageInput;
